import { render, staticRenderFns } from "./RolePermissionDialog.vue?vue&type=template&id=2e752161&scoped=true"
import script from "./RolePermissionDialog.vue?vue&type=script&lang=js"
export * from "./RolePermissionDialog.vue?vue&type=script&lang=js"
import style0 from "./RolePermissionDialog.vue?vue&type=style&index=0&id=2e752161&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e752161",
  null
  
)

export default component.exports